import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';
import type { User } from '@promo/shared';

/**
 * Custom hook to fetch a User by their ID
 * @param userId - the ID of the user to fetch
 */
export function useUser(userId: string) {
  return useQuery<User, Error>({
    queryKey: ['user', userId],
    queryFn: () => get<User>(`/users/${userId}`),
    enabled: Boolean(userId),
  });
} 